/** @jsxImportSource @emotion/react */
import type { ReactElement } from 'react';
import { ODSGroup, themeColors } from 'bc-ods';
import type { AuthAccountWithPassType } from 'api-client/accounts';
import type { DiscoveredAccountDetails } from 'bc-model';
import AccountAvatar from 'components/Utils/Account/AccountAvatar';
import { includeBasePath } from 'utils/url-utils';

type Props = {
  profile: AuthAccountWithPassType;
  discoveredAccountDetails?: DiscoveredAccountDetails;
};

function MatchingAccountCard({ profile, discoveredAccountDetails }: Props): ReactElement {
  const details = [
    discoveredAccountDetails?.rank,
    discoveredAccountDetails?.jobTitle,
    discoveredAccountDetails?.organization,
  ]
    .filter(Boolean)
    .join(', ');

  const avatarAccount = {
    ...profile,
    avatarColor: discoveredAccountDetails?.avatarColor ?? profile.avatarColor,
  };

  return (
    <ODSGroup
      className="d-flex align-items-center p-3"
      css={{ border: `1px solid ${themeColors.border}`, borderRadius: '0.5rem', gap: '0.625rem' }}
      data-testid="account-info-card"
    >
      <div css={(theme) => ({ width: theme.sizing.pixels(28), height: theme.sizing.pixels(28) })}>
        <AccountAvatar account={avatarAccount} className="h-100" />
      </div>
      <div className="d-flex flex-column" css={{ gap: '0.25rem', minWidth: 0 }}>
        <div
          data-testid="account-email"
          className="fw-medium text-truncate"
          css={{ fontSize: '0.875rem' }}
        >
          {profile.email}
        </div>
        {discoveredAccountDetails && (
          <div
            className="d-flex align-items-center"
            css={{ gap: '0.375rem', fontSize: '0.75rem', color: themeColors.secondary }}
            data-testid="account-org-role"
          >
            <img
              src={includeBasePath('/assets/onebrief-logo-dark.png')}
              alt="OneBrief Logo"
              css={(theme) => ({ width: theme.sizing.pixels(72), height: 'auto' })}
            />
            {details && (
              <>
                <span aria-hidden>·</span>
                <span className="text-truncate">{details}</span>
              </>
            )}
          </div>
        )}
      </div>
    </ODSGroup>
  );
}

export default MatchingAccountCard;
